// Converts the sign-in service's WebAuthn JSON (go-webauthn, base64url fields)
// to browser options and the browser's credentials back to JSON. Done by hand
// because PublicKeyCredential.parse*OptionsFromJSON isn't in every browser yet.
import { fromBytes, toBytes } from "./b64.ts";

type Json = Record<string, any>;

const descriptors = (list?: Json[]) => list?.map(d => ({ ...d, id: toBytes(d.id) }));

export function creationOptions(options: Json): CredentialCreationOptions {
  const pk = options.publicKey;
  return { publicKey: { ...pk, challenge: toBytes(pk.challenge), user: { ...pk.user, id: toBytes(pk.user.id) },
    excludeCredentials: descriptors(pk.excludeCredentials) } };
}

export function requestOptions(options: Json): CredentialRequestOptions {
  const pk = options.publicKey;
  return { publicKey: { ...pk, challenge: toBytes(pk.challenge), allowCredentials: descriptors(pk.allowCredentials) } };
}

export function credentialJSON(c: PublicKeyCredential): Json {
  const r = c.response as AuthenticatorAttestationResponse & AuthenticatorAssertionResponse;
  const response: Json = { clientDataJSON: fromBytes(r.clientDataJSON) };
  if ("attestationObject" in r && r.attestationObject) {
    response.attestationObject = fromBytes(r.attestationObject);
    if (typeof r.getTransports === "function") response.transports = r.getTransports();
  } else {
    response.authenticatorData = fromBytes(r.authenticatorData);
    response.signature = fromBytes(r.signature);
    if (r.userHandle) response.userHandle = fromBytes(r.userHandle);
  }
  return { id: c.id, rawId: fromBytes(c.rawId), type: c.type, response, clientExtensionResults: c.getClientExtensionResults?.() ?? {} };
}
